import { useEffect, useRef } from 'react';

const stats = [
  { value: '100–200', label: 'Participantes de alto perfil' },
  { value: '500K+', label: 'Impressões nas redes sociais' },
  { value: '30+', label: 'Peças de conteúdo para patrocinadores' },
  { value: '4h', label: 'De imersão estratégica exclusiva' },
];

export default function NumbersSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.animate-target').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0)';
              }, i * 150);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="bg-obsidian py-24 md:py-28 px-6 relative overflow-hidden border-t border-b border-gold/20"
    >
      {/* Background texture */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="w-full h-full" style={{
          backgroundImage: 'repeating-linear-gradient(45deg, #C8A951 0, #C8A951 1px, transparent 0, transparent 50%)',
          backgroundSize: '20px 20px',
        }} />
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-6">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="animate-target opacity-0 transition-all duration-700 text-center"
              style={{ transform: 'translateY(30px)', transitionDelay: `${index * 150}ms` }}
            >
              <div className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-gold mb-3">
                {stat.value}
              </div>
              <div className="w-8 h-px bg-gold/40 mx-auto mb-3" />
              <p className="font-sans text-xs text-cream/45 uppercase tracking-widest leading-relaxed" style={{ letterSpacing: '0.15em' }}>
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
